import React from 'react'

import MailIcon from '@mui/icons-material/Mail';
import CallIcon from '@mui/icons-material/Call';
import LocationPinIcon from '@mui/icons-material/LocationPin';
function TermandCondition() {
    return (
        <>
            <div className='ms-hero-banner-sec' style={{ paddingTop: '80px' }}>
                <div className="container">
                    <div className='row  align-items-center'>
                        <div className='col-lg-6'>
                            <div className='ms-banner-heading'>
                                <span className='ms-takeaways'> Well Defined Conditions</span>
                                <h1 className='fs-1 pt-3 fw-semibold'>Terms & Conditions</h1>
                                <p className='fw-lighter' style={{ fontSize: '20px' }}>By accessing or using our platform, you agree to these terms and conditions.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className='container pt-5 term-wrap'>
                <p className='fw-medium pb-3'><strong>Effective Date:</strong> 03/06/2026</p>
                <p className='fw-medium pb-4'>Welcome to SnapRupee ("Platform"), operated by <strong>Surya Jyoti Leasing and Finance Limited</strong> ("Company", "we", "our", or "us").</p>
                <p className='fw-medium pb-4'>By accessing, browsing, or using this website, you agree to be bound by these Terms & Conditions. If you do not agree with any part of these terms, please discontinue use of the Platform.</p>

                <h3 className=''>1. About the Platform</h3>
                <p>SnapRupee is a digital platform operated by Surya Jyoti Leasing and Finance Limited that enables users to access information regarding loan products, submit applications, upload documents, and communicate with the Company.</p>
                <p className='pt-2'>Use of the Platform does not guarantee loan approval, loan amount, interest rate, tenure, or disbursal.</p>

                <h3 className=''>2. Eligibility</h3>
                <p>To use the Platform, users must:</p>
                <div className=''>
                    <ul>
                        <li>Be legally competent to enter into a contract under applicable laws.</li>
                        <li>Provide accurate and complete information.</li>
                        <li>Use the Platform only for lawful purposes.</li>
                    </ul>
                </div>
                <p className='pt-2'>The Company reserves the right to reject or discontinue any application that does not meet eligibility requirements or internal policies.</p>

                <h3 className=''>3. User Responsibilities</h3>
                <p>Users agree to:</p>
                <div className=''>
                    <ul>
                        <li>Provide true, accurate, and complete information.</li>
                        <li>Maintain confidentiality of OTPs and account credentials.</li>
                        <li>Update information whenever required.</li>
                        <li>Not misuse, disrupt, or attempt unauthorized access to the Platform.</li>
                    </ul>
                </div>
                <p className='pt-2'>Any false, misleading, or fraudulent information may result in rejection of applications and restriction of access to the Platform.</p>

                <h3 className=''>4. Loan Application & Approval</h3>
                <p>Submission of an application does not constitute approval of a loan.</p>
                <p className='pt-2'>All loan applications are subject to:</p>
                <div className=''>
                    <ul>
                        <li>Verification of information</li>
                        <li>Eligibility assessment</li>
                        <li>Internal credit evaluation</li>
                        <li>Applicable regulatory requirements</li>
                    </ul>
                </div>
                <p className='pt-2'>The Company reserves the right to approve, reject, or modify any application at its sole discretion in accordance with applicable laws and internal policies.</p>

                <h3 className=''>5. Fees & Charges</h3>
                <p>Any applicable fees, charges, interest rates, penalties, or other costs relating to a loan product will be disclosed to the customer before acceptance of any loan offer.</p>
                <p className='pt-2'>Customers are advised to review all applicable terms carefully before proceeding.</p>

                <h3 className=''>6. Electronic Communication</h3>
                <p>By using the Platform, users consent to receive communications through:</p>
                <div className=''>
                    <ul>
                        <li>SMS</li>
                        <li>Email</li>
                        <li>Phone Calls</li>
                        <li>WhatsApp (where applicable)</li>
                        <li>Platform Notifications</li>
                    </ul>
                </div>
                <p className='pt-2'>Such communications may include application updates, verification requests, service messages, and regulatory notifications.</p>

                <h3 className=''>7. Privacy & Data Usage</h3>
                <p>Use of the Platform is also governed by the Privacy Policy available on the website.</p>
                <p className='pt-2'>By submitting information through the Platform, users consent to the collection, processing, verification, and storage of information in accordance with applicable laws and the Privacy Policy.</p>

                <h3 className=''>8. Intellectual Property</h3>
                <p>All content on this Platform, including:</p>
                <div className=''>
                    <ul>
                        <li>Logos</li>
                        <li>Trademarks</li>
                        <li>Designs</li>
                        <li>Graphics</li>
                        <li>Text</li>
                        <li>Software</li>
                    </ul>
                </div>
                <p className='pt-2'>is owned by or licensed to the Company and is protected under applicable intellectual property laws.</p>
                <p className='pt-2'>Users shall not copy, reproduce, modify, distribute, or commercially exploit any content without prior written permission.</p>

                <h3 className=''>9. Limitation of Liability</h3>
                <p>The Company shall not be liable for any indirect, incidental, consequential, or special damages arising from:</p>
                <div className=''>
                    <ul>
                        <li>Use of the Platform</li>
                        <li>Delays in processing</li>
                        <li>Technical interruptions</li>
                        <li>Third-party service failures</li>
                        <li>User-provided information</li>
                    </ul>
                </div>
                <p className='pt-2'>The Platform is provided on an "as available" basis without warranties of uninterrupted availability.</p>

                <h3 className=''>10. Third-Party Services</h3>
                <p>The Platform may integrate with third-party service providers for verification, analytics, communication, payment processing, or other operational requirements.</p>
                <p className='pt-2'>The Company shall not be responsible for the content, policies, or practices of third-party websites or services.</p>

                <h3 className=''>11. Suspension or Termination</h3>
                <p>The Company reserves the right to suspend, restrict, or terminate access to the Platform if:</p>
                <div className=''>
                    <ul>
                        <li>False information is provided.</li>
                        <li>Fraudulent activity is suspected.</li>
                        <li>Applicable laws or policies are violated.</li>
                        <li>Security concerns arise.</li>
                    </ul>
                </div>

                <h3 className=''>12. Modifications</h3>
                <p>The Company reserves the right to update these Terms & Conditions from time to time.</p>
                <p className='pt-2'>Any revised version will become effective upon publication on the website.</p>

                <h3 className=''>13. Governing Law</h3>
                <p>These Terms & Conditions shall be governed by and construed in accordance with the laws of India.</p>
                <p className='pt-2'>Any disputes arising from the use of the Platform shall be subject to the jurisdiction of the competent courts where the Company's registered office is located.</p>

                <h3 className=''>14. Contact Information</h3>
                <p>For any questions regarding these Terms & Conditions, please contact:</p>
                <hr style={{ marginTop: '30px', marginBottom: '30px' }} />
                <p className='fw-medium pb-3'><strong>Surya Jyoti Leasing and Finance Limited</strong></p>
                <p style={{ fontSize: '16px', lineHeight: '30px' }}>
                    <LocationPinIcon className='ms-text-secondary' style={{ marginRight: '10px' }} />
                    <strong>Registered Office:</strong> 407-408, B-08, ITL Tower, Netaji Subhash Place, Pitampura, New Delhi, Delhi 110034<br />
                    <MailIcon className='ms-text-secondary' style={{ marginRight: '10px' }} /> 
                    <strong>Email:</strong> <a href='mailto:care@snaprupee.in'>care@snaprupee.in</a><br />
                    <CallIcon className='ms-text-secondary' style={{ marginRight: '10px' }} /> 
                    <strong>Customer Support:</strong> 9289567208<br />
                    <strong>Website:</strong> <a href='https://www.snaprupee.in' target='_blank' rel='noopener noreferrer'>www.snaprupee.in</a>
                </p>
                <hr style={{ marginTop: '30px', marginBottom: '30px' }} />
                
                <h3 className=''>Important Disclaimer</h3>
                <p>Submission of an application through SnapRupee does not guarantee loan approval. Loan approval, loan amount, interest rate, tenure, fees, charges, and disbursal timelines are subject to customer eligibility, verification, internal credit policies, and applicable regulatory requirements.</p>
                <p className='pb-5'>By using the Platform, you acknowledge that you have read, understood, and agreed to these Terms & Conditions.</p>
            </div>
        </>
    )
}

export default TermandCondition
